var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgShareIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M12.517 4.176a2.357 2.357 0 0 1 3.303 0 2.273 2.273 0 0 1 0 3.242l-.687.679a.75.75 0 0 0 1.055 1.066l.687-.678a3.772 3.772 0 0 0 0-5.376 3.857 3.857 0 0 0-5.413 0L8.125 6.408a3.772 3.772 0 0 0 0 5.375.75.75 0 1 0 1.055-1.066 2.272 2.272 0 0 1 0-3.242l3.337-3.3Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M7.483 15.824c-.91.901-2.392.901-3.303 0a2.272 2.272 0 0 1 0-3.242l.687-.679a.75.75 0 0 0-1.055-1.066l-.687.678a3.772 3.772 0 0 0 0 5.376 3.857 3.857 0 0 0 5.413 0l3.337-3.299a3.772 3.772 0 0 0 0-5.375.75.75 0 0 0-1.055 1.066 2.272 2.272 0 0 1 0 3.242l-3.337 3.3Z"
})));
export { SvgShareIcon as ReactComponent };